import {
  Box,
  Button as MuiButton,
  Checkbox,
  Chip as MuiChip,
  Stack,
  styled,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { theme } from 'src/utils';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const HeaderWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderText = styled(Typography)`
  font-size: 2.5rem;
  line-height: 1.2;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin: 0;
  font-family: 'Roboto';
`;

export const ActionButtonsContainer = styled(Stack)`
  flex-shrink: 0;
`;

export const FooterButtonsContainer = styled(Box)`
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  gap: 16px;
  z-index: 1000;
`;

export const Button = styled(MuiButton)<{ btncolor?: string }>`
  max-height: 40px;
  color: ${(props: { btncolor: string }) =>
    props.btncolor ? props.btncolor : 'undefined'};
`;

export const CustomTableHead = styled(TableHead)(
  ({ theme }) => `
    th {
      border-bottom: 2px solid ${theme.palette.brand.black}; 
      font-weight : 700; 
    }
  `,
);

export const CustomTableCell = styled(TableCell)<{
  width: number;
  isChildRow: boolean;
}>`
  width: ${(props: { width: number }) => `${props.width}px`};
  border: ${(props: { isChildRow: boolean }) => props.isChildRow && `none`};
  padding: ${(props: { isChildRow: boolean }) => props.isChildRow && '0 0 0 0'};
`;

export const Chip = styled(MuiChip)(
  ({ theme, enabled, checked }) => `

  background-color: transparent;
  color: ${
    enabled
      ? checked
        ? theme.palette.success.main
        : theme.palette.error.dark
      : theme.palette.error.dark
  };
  };
`,
);

export const VariationChip = styled(MuiChip)(
  ({ theme, checked, isInherited, isParentChecked, enabled }) => `

{  background-color: transparent;
  color: ${
    isInherited
      ? isParentChecked
        ? enabled
          ? theme.palette.success.main
          : theme.palette.error.dark
        : theme.palette.error.dark
      : checked
      ? enabled
        ? theme.palette.success.main
        : theme.palette.error.dark
      : theme.palette.error.dark
  };}
`,
);

export const TableRowContainer = styled(TableRow)(
  () => `
  background-color: 'inherit'}; 
  `,
);

export const LinkContainer = styled(Button)(
  ({ theme }) => `
  padding-left: 14px;
  padding-right: 0;
  &>a {
    color:${theme.palette.primary.main};
  }
`,
);

export const CustomCheckbox = styled(Checkbox)`
  &.MuiCheckbox-indeterminate {
    .MuiSvgIcon-root {
      fill: ${theme.palette.primary.light};
    }
  }
`;
